<template>
  <!-- Content -->
  <CRow>
    <Modal :modal="modal"></Modal>

    <CCol col="12">
      <CRow>
        <CCol lg="12">
          <div class="d-flex align-items-center justify-content-end mb-3">
            <a
              href="javascript:void(0)"
              @click="$router.go(-1)"
            ><CIcon
              name="cil-arrow-left"
              class="mr-2"
            />Voltar</a>
          </div>
        </CCol>
      </CRow>
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            {{ $route.params.id ? 'Editar Usuário' : 'Cadastrar Usuário' }}
          </h4>
          <div class="d-flex align-items-center">
            <div class="ml-2 d-flex align-items-center">
              <label class="mb-0"><b>Status</b></label>
              <CSwitch
                type="checkbox"
                color="success"
                variant="3d"
                class="mx-2"
                v-bind="labelIcon"
                :checked.sync="form.status"
              />
            </div>
          </div>
        </CCardHeader>

        <CForm @submit.prevent="send">
          <CCardBody>
            <CRow>
              <CCol
                lg="12"
                md="12"
                sm="12"
              >
                <CRow>
                  <CCol
                    lg="6"
                    md="6"
                    sm="12"
                  >
                    <CInput
                      v-model="form.name"
                      name="name"
                      label="Nome*"
                      placeholder="Nome do usuário"
                      required
                      :disabled="processing"
                    />
                  </CCol>
                  <CCol
                    lg="6"
                    md="6"
                    sm="12"
                  >
                    <CInput
                      v-model="form.email"
                      name="email"
                      label="E-mail*"
                      type="email"
                      placeholder="exemplo@mail.com"
                      required
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol
                    lg="6"
                    md="6"
                    sm="12"
                  >
                    <CInput
                      v-model="form.password"
                      label="Senha*"
                      type="password"
                      name="password"
                      placeholder="************"
                      autocomplete="false"
                      :required="$route.params.id ? false : true"
                      :disabled="processing"
                      @blur="checkConfirmationPassword"
                    />
                    <PasswordRequirements :password="form.password" />
                  </CCol>
                  <CCol
                    lg="6"
                    md="6"
                    sm="12"
                  >
                    <CInput
                      id="confirm_password"
                      v-model="form.password_confirmation"
                      label="Confirmação da senha*"
                      type="password"
                      placeholder="************"
                      autocomplete="false"
                      :required="$route.params.id ? false : true"
                      :is-valid="passwordErrors.confirmation"
                      invalid-feedback="Senhas senha incorreta"
                      :disabled="processing"
                      @blur="checkConfirmationPassword"
                    />
                    <div
                      v-if="differentPasswords && form.password_confirmation"
                      class="compare-passwords"
                      :class="differentPasswords ? 'different-passwords' : ''"
                    >
                      As senhas não conferem
                    </div>
                    <div
                      v-if="!differentPasswords && form.password_confirmation"
                      class="compare-passwords"
                      :class="!differentPasswords ? 'equal-passwords' : ''"
                    >
                      As senhas conferem
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CForm>
      </CCard>
      <CRow v-if="$route.params.id">
        <CCol sm="12">
          <CardLog :log="log" />
        </CCol>
      </CRow>
    </CCol>
    <CCol class="my-4">
      <div class="d-flex justify-content-end align-items-center">
        <a
          v-if="$route.params.id"
          href="javascript:void(0)"
          class="mr-3"
          @click="resetForm"
        >Limpar Alterações</a>
        <CInputCheckbox
          v-else
          label="Criar outro"
          class="mr-3"
          :disabled="processing"
          @update:checked="setRedirect"
        />
        <CButton
          color="success"
          type="submit"
          :disabled="processing"
          @click="send"
        >
          {{ processing ? 'Salvando...' : 'Salvar' }}
        </CButton>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import UserService from '@/services/user.service'
import CardLog from '@/components/ui/CardLog'
import Modal from '@/components/ui/Modal'
import PasswordRequirements from '@/components/ui/PasswordRequirements'
import { cloneDeep } from 'lodash'
import moment from 'moment'

export default {
  metaInfo: {
    title: 'Usuário',
    titleTemplate: '%s - Área Administrativa OW Interactive'
  },

  components: {
    CardLog,
    Modal,
    PasswordRequirements
  },

  data () {
    return {
      user: {
        status: true,
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      form: {},
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      log: {},
      passwordErrors: {
        confirmation: null
      },
      processing: false,
      redirect: true,
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      }
    }
  },

  computed: {
    differentPasswords: function () {
      let result
      const confirm_password = document.getElementById('confirm_password')
      if (confirm_password) {
        confirm_password.setCustomValidity('')
      }

      if (
        this.form.password_confirmation &&
        this.form.password !== this.form.password_confirmation
      ) {
        result = true
        confirm_password.setCustomValidity('As senhas não conferem')
      } else if (
        this.form.password_confirmation &&
        this.form.password === this.form.password_confirmation
      ) {
        result = false
        confirm_password.setCustomValidity('')
      }
      return result
    }
  },

  async created () {
    if (this.$route.params.id) {
      const response = await UserService.getUserInformation(
        this.$route.params.id
      )

      this.user = {
        name: response.name,
        email: response.email,
        status: !!response.status,
        role: response.roles.length > 0 && response.roles[0].id,
        password: '',
        password_confirmation: ''
      }
      this.log = {
        created_by: response.created ? response.created.name : 'Seed',
        created_at: moment(response.created_at).format('DD/MM/YYYY HH:mm'),
        updated_by: response.updated ? response.updated.name : null,
        updated_at: moment(response.updated_at).format('DD/MM/YYYY HH:mm')
      }
    }

    this.setUser()
  },

  methods: {
    /**
     * Validates confirmation password
     */
    checkConfirmationPassword () {
      if (
        this.user.password &&
        this.user.password !== this.user.password_confirmation
      ) {
        this.passwordErrors.confirmation = false
      } else {
        this.passwordErrors.confirmation = null
      }
    },

    /**
     * Set user's data to edit
     */
    setUser () {
      this.form = cloneDeep(this.user)
    },

    /**
     * Clear changes on user data
     */
    resetForm () {
      this.setUser()
    },

    /**
     * Should redirect or create another user
     */
    setRedirect (event) {
      this.redirect = !event
    },

    roleChanged (value) {
      this.form.role = value
    },

    /**
     * Store user's data to endpoint
     */
    async send () {
      this.processing = true

      const data = { ...this.form, id: this.$route.params.id }

      let response
      let message

      if (this.$route.params.id) {
        response = await UserService.updateUser(this.$route.params.id, data)
        message = `O usuário <b>${this.form.name}</b> foi atualizado com sucesso`
      } else {
        response = await UserService.storeUser(data)
        message = `O usuário <b>${this.form.name}</b> foi cadastrado com sucesso`
      }
      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          setTimeout(() => {
            this.processing = false
            // this.$router.go(-1)
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.processing = false
          this.resetForm()
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data[0].message || response.data,
          color: 'danger'
        }

        this.processing = false
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message:
            'Houve um erro ao salvar o usuario, por favor tente novamente',
          color: 'danger'
        }

        this.processing = false
      }
    }
  }
}
</script>

<style lang="scss">
.compare-passwords {
  position: relative;
  top: -10px;
}

.equal-passwords {
  color: #3c9d74;
}

.different-passwords {
  color: #ef5b5b;
}
</style>
